import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_plane-booking-black.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_briefcase.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_box.svg'


const _hoisted_1 = { class: "flex flex-1 items-center justify-between py-4 px-6 bg-gray-lp-1200 rounded-lg" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = { class: "text-xs font-semibold capitalize" }
const _hoisted_5 = { class: "icon-container flex w-16 flex justify-center items-center relative" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "absolute top-1/2 left-0 w-full h-px -translate-y-1/2 bg-black-lp-100" }, null, -1)
const _hoisted_7 = {
  style: {"box-shadow":"0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A"},
  class: "rounded-full w-9 h-9 flex items-center justify-center border border-gray-lp-200 bg-white z-10"
}
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "text-xs font-semibold" }
const _hoisted_10 = { class: "text-2xl font-bold" }
const _hoisted_11 = { class: "flex flex-1 gap-2" }
const _hoisted_12 = { class: "flex flex-1 items-center justify-start p-2 border border-gray-lp-1400 rounded-lg min-w-[200px]" }
const _hoisted_13 = { class: "flex items-center justify-center w-10 h-10" }
const _hoisted_14 = { class: "text-xs font-semibold" }
const _hoisted_15 = { class: "text-xl font-bold" }
const _hoisted_16 = { class: "flex flex-1 items-center justify-start p-2 border border-gray-lp-1400 rounded-lg min-w-[200px]" }
const _hoisted_17 = { class: "flex items-center justify-center w-10 h-10" }
const _hoisted_18 = { class: "text-xs font-semibold" }
const _hoisted_19 = { class: "text-xl font-bold" }
const _hoisted_20 = { class: "text-sm font-normal text-gray-lp-800" }
const _hoisted_21 = {
  key: 0,
  class: "flex items-center justify-center py-2 px-4 bg-red-lp-50 border border-red-lp-2400 rounded-lg w-16"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-xl font-bold text-red-lp-2400" }, "DG", -1)
const _hoisted_23 = {
  key: 1,
  class: "flex items-center justify-center py-2 px-4 bg-yellow-lp-400 border border-yellow-lp-1300 rounded-lg w-16"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "text-xl font-bold text-yellow-lp-1300" }, "K", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.customClass, "flex gap-5 w-full"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.origin), 1),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.originName), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("img", {
            src: _imports_0,
            class: "",
            style: {"width":"18px","height":"18px"},
            alt: _ctx.$t('cargoV2.create.searchFlightHeader.alt.plane')
          }, null, 8, ["alt"])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.destinationName), 1),
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.destination), 1)
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("img", {
            src: _imports_1,
            class: "w-5",
            alt: _ctx.$t('cargoV2.create.searchFlightHeader.alt.briefcase')
          }, null, 8, ["alt"])
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("cargo.v2.flight.search.header.totalPieces")), 1),
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.totalKoli), 1)
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("img", {
            src: _imports_2,
            class: "w-5",
            alt: _ctx.$t('cargoV2.create.searchFlightHeader.alt.box')
          }, null, 8, ["alt"])
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("cargo.v2.flight.search.header.grossVolumeWeight")), 1),
          _createVNode("div", _hoisted_19, [
            _createTextVNode(_toDisplayString(_ctx.grossWeight) + "/" + _toDisplayString(_ctx.volumeWeight) + " ", 1),
            _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("cargoV2.create.common.kg")), 1)
          ])
        ])
      ]),
      (_ctx.hasDangerousGoods)
        ? (_openBlock(), _createBlock("div", _hoisted_21, [
            _hoisted_22
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasQuarantine)
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            _hoisted_24
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}